// extracted by mini-css-extract-plugin
export default {"instructions":"SpeakingChallenge_instructions__KK6im"};